import { Header } from "../../components/Header";
import React, { useEffect, useState } from 'react';
import { getHistory, saveHistory } from "../../utils/localStorage";
import './History.scss';
import moment from "moment";

const History = () => {
    const [tests, setTests] = useState<any[]>([]);
    const [tab, setTab] = useState('today');
    const [showDate, setDate] = useState(moment().format('DD.MM.yyyy'))
    const hist = getHistory();

    useEffect(() => {
        if (hist) loadResults();
        // eslint-disable-next-line
    }, [hist]);

    useEffect(() => {
        loadResults();
        setDate(tab === 'today' ? moment().format('DD.MM.yyyy') : moment().subtract(1, 'd').format('DD.MM.yyyy'))
        // eslint-disable-next-line
    }, [tab])

    const loadResults = () => {
        if (hist) {
            const results = JSON.parse(hist);
            const now = new Date();
            const today = now.getDate();
            const thisMonth = now.getMonth();
            const todayResults = results.filter((r: any) => {
                const date = new Date(r.confirmed_at);
                const day = date.getDate();
                const month = date.getMonth();
                return month === thisMonth && day === (tab === 'today' ? today : today-1)
            });
            setTests(todayResults);
            cleanUpHistory(results);
        }
    }

    const cleanUpHistory = (results: any) => {
        const now = new Date();
        const today = now.getDate();
        const thisMonth = now.getMonth();

        const cleanHistory = results.filter((r:any) => {
            const date = new Date(r.confirmed_at);
            const day = date.getDate();
            const month = date.getMonth();

            return month === thisMonth && day >= today - 1;
        })

        saveHistory(JSON.stringify(cleanHistory));

    }

    return (
        <div className="layout-column flex">
            <Header />

            <div className="page-container flex">
                <h2>Verifications history</h2>
                <h5>for {showDate}</h5>
                <div className="tabs no-print">
                    <button className={`button text-button ${tab === 'yesterday' && 'active'}`} onClick={() => setTab('yesterday')}>Yesterday</button>
                    <button className={`button text-button ${tab === 'today' && 'active'}`} onClick={() => setTab('today')}>Today</button>
                </div>

                {tests.length > 0 && 
                    <>
                        <table className="historyTable">
                            <thead>
                                <tr>
                                    <th>Validated at</th>
                                    <th>Status</th>
                                    <th>Testee</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tests.map((item, i) => (
                                    <tr key={`result-${i}`}>
                                        <td>{moment(item.confirmed_at).format("DD MMM - HH:mm")}</td>
                                        <td>{item.status}</td>
                                        <td>{item.testee}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className="spacer"></div>
                    </>
                }
                {tests.length === 0 && (
                    <div className="noValidations">You have no verifications done today</div>
                )}
                <button className="button filled-button no-print" onClick={() => window.print()}>Print results</button>
            </div>
        </div>
    )
}

export default History;